import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { textM } = typographyStyles;
const { ui } = constants.colors;

export const modalStyles = {
  root: {
    zIndex: 10,
  },
  title: {
    color: ui.neutral[600],
    fontSize: "1.5rem",
  },
  scrollableBody: {
    minHeight: "60%",
    maxHeight: "60%",
    [breakpoint.upTo("xs")]: {
      minHeight: "calc(75% - 145px)",
      maxHeight: "calc(75% - 145px)",
    },
  },
  modalContentWrapper: {
    maxWidth: "800px !important",
    maxHeight: "380px !important",
    [breakpoint.upTo("xs")]: {
      maxWidth: "100% !important",
      maxHeight: "100% !important",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "end",
  },
};

export const subtitleStyles = [
  textM,
  {
    margin: "0",
    color: ui.neutral[600],
    fontSize: "1.25rem",
    marginBottom: "24px",
  },
];

export const buttonStyles = {
  root: {
    whiteSpace: "nowrap",
    marginTop: "24px",
    [breakpoint.upTo("xs")]: {
      margin: "8px 0",
      width: "100%",
    },
  },
};

export const linkStyles = {
  color: ui.core[700],
  textDecoration: "underline",
  cursor: "pointer",
};
